module.exports = __webpack_public_path__ + "img/selected0-min.de5cc4ae.png";